import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { GenericLinkDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-equal-height',
  templateUrl: './equal-height.component.html',
  styleUrls: ['./equal-height.component.scss'],
  standalone: true,
  imports: [RichTextWrapperComponent, JssModule, GenericLinkDirective],
})
export class EqualHeightComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
}
